


























































































































































































import Vue from "vue";
import { MassnahmenFilter } from "@/types/Massnahme";
import {
  Element,
  Initiator,
  Region,
  Risikogewaesser,
  Schlagwort,
  Status,
  Zustaendigkeit,
} from "@/types";
import { erklServiceInstance } from "@/services/ErklService";
import { RequestError } from "@/services/AuthService";
import AlertService from "@/services/libs/AlertService";
import StorageService from "@/services/libs/StorageService";

/**
 * Emits @change for filter change event
 */
export default Vue.extend({
  name: "KommunenFilter",
  props: {
    disableFilter: {
      type: Boolean,
      default: false,
    },
  },
  data: function () {
    return {
      extendFilter: false,
      isLoading: false,
      filter: {} as MassnahmenFilter,
      schlagworte: [] as Schlagwort[],
      zustaendigkeiten: [] as Zustaendigkeit[],
      risikogewaesser: [] as Element[],
      regionen: [] as Element[],
      initiierung: [] as Element[],
      status: [] as Element[],
    };
  },
  computed: {
    filteredSchlagworte(): Schlagwort[] {
      return this.filtered(this.schlagworte, this.filter?.schlagwort);
    },
    filteredRisikogewaesser(): Schlagwort[] {
      return this.filtered(this.risikogewaesser, this.filter?.risikogewaesser);
    },
    filteredRegionen(): Schlagwort[] {
      return this.filtered(this.regionen, this.filter?.region);
    },
    filteredInitiierung(): Schlagwort[] {
      return this.filtered(this.initiierung, this.filter?.initiierung);
    },
  },

  beforeMount() {
    this.filter = StorageService.get("MassnahmenFilter") || {};
    this.extendFilter =
      !!this.filter.schlagwort ||
      !!this.filter.status3zyklus ||
      !!this.filter.status2zyklus ||
      !!this.filter.initiierung ||
      !!this.filter.region ||
      !!this.filter.risikogewaesser ||
      !!this.filter.zustaendigkeit;
  },

  mounted() {
    this.isLoading = true;

    Promise.all([
      erklServiceInstance
        .getSchlagworte()
        .then((data: Schlagwort[]) => (this.schlagworte = data)),
      erklServiceInstance
        .getAllInitiators()
        .then((data: Initiator[]) => (this.initiierung = data)),
      erklServiceInstance
        .getRegionen(null)
        .then((data: Region[]) => (this.regionen = data)),

      erklServiceInstance
        .getRisikogewaesser()
        .then((data: Risikogewaesser[]) => (this.risikogewaesser = data)),

      erklServiceInstance
        .getStatus()
        .then((data: Status[]) => (this.status = data)),

      erklServiceInstance
        .getRegionalstellen()
        .then(
          (data: Zustaendigkeit[]) =>
            (this.zustaendigkeiten = [{ id: "", bez: "Alle" }, ...data]),
        ),
    ])
      .catch((error: RequestError) =>
        AlertService.error(
          "Aktuell besteht keine Verbindung!",
          "Bitte versuchen Sie es in einiger Zeit erneut!",
          "Wenn das Problem weiterhin besteht, informieren Sie bitte den Helpdesk!",
          "Fehlermeldung: " + error.message,
        ),
      )
      .finally(() => (this.isLoading = false));
  },
  methods: {
    filtered(elements: Element[], query: string | undefined) {
      if (!Array.isArray(elements)) return [];
      return elements.filter(
        (element: Element) =>
          element.bez
            .toString()
            .toLowerCase()
            .indexOf(query?.toLowerCase() || "") >= 0,
      );
    },
    onClear() {
      this.filter = {} as MassnahmenFilter;
    },
    onSubmit() {
      StorageService.set("MassnahmenFilter", this.filter);
      this.$emit("submit", this.filter);
    },
    onKeyUp(event: KeyboardEvent) {
      // Number 13 is the "Enter" key on the keyboard
      if (event.keyCode === 13) {
        // Cancel the default action, if needed
        event.preventDefault();
        // Trigger submit event
        this.onSubmit();
      }
    },
  },
});
